module.exports = __webpack_public_path__ + "Roboto-Regular.6a561d68369fd1fb9768.eot";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.eot
// module id = 44
// module chunks = 16